export default __webpack_public_path__ + "static/media/capex-thop-big.0b0a5eb4.png";